/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserDto } from '../../models/user-dto';

export interface UsersControllerFindUserByEmailOrPhoneNumber$Params {
  identifier: string;

  /**
   * Store identifier for multi-tenant requests.
   */
  'terrific-store-id'?: string;
}

export function usersControllerFindUserByEmailOrPhoneNumber(
  http: HttpClient,
  rootUrl: string,
  params: UsersControllerFindUserByEmailOrPhoneNumber$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<UserDto>> {
  const rb = new RequestBuilder(rootUrl, usersControllerFindUserByEmailOrPhoneNumber.PATH, 'get');
  if (params) {
    rb.query('identifier', params.identifier, {});
    rb.header('terrific-store-id', params['terrific-store-id'], {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserDto>;
    })
  );
}

usersControllerFindUserByEmailOrPhoneNumber.PATH = '/api/v1/users/find-by-email-or-phone-number';
